import short from 'short-uuid';

const URL_SAFE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.~';

const translator = short(URL_SAFE_CHARS);

// UUID를 URL-safe short ID로 변환하는 함수
export function encodeShort(uuid?: string) {
  if (!uuid) {
    return uuid;
  }
  return translator.fromUUID(uuid);
}

// URL-safe short ID를 UUID로 변환하는 함수
export function decodeShort(sUuid?: string) {
  if (!sUuid) {
    return sUuid;
  }
  return translator.toUUID(sUuid);
}
